<template>
  <el-table
    class="add-table"
    max-height="300"
    :data="dataList"
    style="width: 100%"
    row-key="type"
  >
    <el-table-column align="center" label="收款项" width="100" prop="typeName"/>
    <el-table-column align="center">
      <template slot="header">
        收款方式
      </template>
      <template slot-scope="scope">
        <span>{{ getPayMethods(scope.row.payMethod) }}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" label="不足月日租金规则" prop="dailyRule">
      <template slot-scope="scope">
        {{ dailyRuleFormate(scope.row.dailyRule) }}
      </template>
    </el-table-column>
    <el-table-column align="center" label="尾期租金规则" prop="lastPeriodRule">
      <template slot-scope="scope">
        {{ lastPeriodRuleFormate(scope.row.lastPeriodRule) }}
      </template>
    </el-table-column>
    <el-table-column align="center">
      <template slot="header">收款金额</template>
      <template slot-scope="scope">
        {{ scope.row.payAmount | addUnit(scope.row) }}
      </template>
    </el-table-column>
    <el-table-column align="center" prop="payDay">
      <template slot="header">
        缴款日
      </template>
      <template slot-scope="scope">
        <!-- "6" 代表收款方式为一次性 -->
        <span v-if="+scope.row.payMode === 6 || +scope.row.payMethod === 6">{{getPayDate(scope.row)}}</span>
        <!-- "3" 代表收款方式为周付 -->
        <span v-else-if="+scope.row.payMode === 3 || +scope.row.payMethod === 3">
          {{ aWeekPayDate(scope.row) }}
        </span>
        <!-- 包含 “-” 说明是日期 -->
        <span v-else-if="typeof scope.row.payDay==='string' && scope.row.payDay.includes('-')">
          {{ scope.row.payDay || '--' }}
        </span>
        <span v-else-if="scope.row.payDay">
          {{ normalPayDate(scope.row) }}
        </span>
        <span v-else>
          {{ +scope.row.payPost === 10 ? '自定义' : '--' }}
        </span>
      </template>
    </el-table-column>
    <el-table-column align="center" label="发车前收款" width="100" prop="advancePayment">
      <template slot-scope="scope">
        <span>{{ getAdvancePayment(scope.row.advancePayment) }}</span>
      </template>
    </el-table-column>
    <el-table-column align="center" label="收款金额保留位数" width="200" prop="amountAccuracy">
      <template slot-scope="scope">
        <span>{{ amountAccuracyFormate(scope.row.amountAccuracy) }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { mapState } from 'vuex'
import { formatNumberWithCommas } from '@/utils'
import orderConfigFn from '@/pages/orders/config/index.js'
import selectOption from '@/store/dict/selectOptionDict'
import { isNewOverdue } from '@/pages/utils/overdue'

export default {
  name: 'OtherCollectionItemsDetailNew',
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
  },
  filters: {
    addUnit(val, rowData) {
      if (isNewOverdue(rowData)) {
        return `未付租金*${rowData.lateFeeProportion}%/日`
      } else if (val === 0 || val) {
        return val
      } else {
        return '--'
      }
    },
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList,
      paymentMethods: (state) => state.global.paymentMethods,
      paymentMethodsTip: (state) => state.global.paymentMethodsTip,
      moneyTip: (state) => state.global.moneyTip,
      advancePaymentList: (state) => state.global.advancePaymentList,
    }),
  },
  data() {
    const { m_weekList } = orderConfigFn.call(this)
    return {
      // eslint-disable-next-line
      formatNumberWithCommas,
      m_weekList: this.formatEnumeration(m_weekList),
    }
  },

  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' })
    this.$store.dispatch('getPaymentMethods', { type: 'payMode' })
    this.$store.dispatch('getPaymentMethods', { type: 'advancePayment' })
  },
  methods: {
    // 获取付款方式
    getPayMethods(type) {
      const payModeItem = this.paymentMethods.find((item) => item.code === type)
      return payModeItem ? payModeItem.name : '--'
    },
    // 发车前收款
    getAdvancePayment(val) {
      const advancePayment = this.advancePaymentList.find((item) => item.code === val)
      return advancePayment ? advancePayment.name : '--'
    },
    // 周付缴款日
    aWeekPayDate(val) {
      if (val.payPost === 1) {
        return `下期${this.m_weekList[val.payDay]}`
      } else if (val.payPost === 0) {
        return `当期${this.m_weekList[val.payDay]}`
      } else if (val.payPost === 10) {
        return '自定义'
      } else {
        return '--'
      }
    },
    normalPayDate(val) {
      if (val.payPost === 1) {
        return `下期${val.payDay}日`
      } else if (val.payPost === 0) {
        return `当期${val.payDay}日`
      } else if (val.payPost === 10) {
        return '自定义'
      } else {
        return '--'
      }
    },
    // 日租金规则
    dailyRuleFormate(val) {
      if (val !== null && (Number(val) === 0 || Number(val) === 1)) {
        return selectOption.dailyRentRules[val]
      }
      return '--'
    },
    // 尾期租金规则
    lastPeriodRuleFormate(val) {
      if (val !== null && (Number(val) === 0 || Number(val) === 1)) {
        return selectOption.lastPeriodRuleList[val]
      }
      return '--'
    },
    // 收款金额保留位数
    amountAccuracyFormate(val) {
      if (val !== null) {
        if (Number(val) === 0) {
          return '金额取整'
        } else if (Number(val) === 2) {
          return '金额保留两位小数'
        } else {
          return '--'
        }
      } else {
        return '--'
      }
    },
    getPayDate(rowData) {
      const { payPost } = rowData
      if (isNewOverdue(rowData)) {
        return '--'
      } else if (Number(payPost) === 10) {
        return '自定义'
      } else {
        return '订单收款起始日'
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.add-table {
  margin-bottom: 20px;
  ::v-deep thead tr {
    background-color: #f7f8fa;
  }
}
#app .add-table ::v-deep thead tr th {
  border: none !important;
}
.ladder-box {
  .ladder-item {
    display: flex;
    align-items: center;
    white-space: nowrap;
  }
}
</style>

